export {
  AdPlacement,
  AdServer,
  AdSlot,
  ContainerId,
  type PlacementId
} from '@schibsted-nmp/advertising-shared';

export {
  AdPositionElements,
  type UseAdPositionElements,
  useAdPositionElements
} from './hooks/useAdPositionElements.js';
export { useIsBannerLoaded } from './hooks/useIsBannerLoaded.js';
export { AsyncEffect } from './hooks/AsyncEffect.js';

export { AdvertisingWebComponent } from './components/AdvertisingWebComponent.js';
export { AdvertisingSlotComponent } from './components/AdvertisingSlotComponent.js';
export { AdvertisingAfsWebComponent } from './components/AdvertisingAfsWebComponent.js';
export {
  AdvertisingClientWebComponent,
  type DisplaySettings
} from './components/AdvertisingClientWebComponent.js';
export { AdvertisingRecircItemPageComponent } from './components/AdvertisingRecircItemPageComponent.js';
export { AdvertisingNativeSlotComponent } from './components/AdvertisingNativeSlotComponent.js';

export { insertBanners } from './utils/insertBanners.js';
export { getPlacementList } from './atoms/placements.js';
export { placementHasIntermingle } from './atoms/placements.js';
